import * as types from "../actions/actionTypes";
import initialState from "./initialState";
const PROGRESS_TYPES = ["BUILD_FORM", "FORM_CONFIG", "INTEGRATE", "EMBED_FORM"];
export default function setTemplateProgressType(
  state = initialState.templateProgressType,
  action
) {
  if (
    action.type == types.SET_TEMPLATE_PROGRESS_TYPE &&
    action.buttonType == "next"
  ) {
    console.log("PROGRESS_TYPES", PROGRESS_TYPES);
    console.log("state", state);
    const nextProgressIndex =
      PROGRESS_TYPES.findIndex((type) => state == type) + 1;
    return PROGRESS_TYPES[nextProgressIndex];
  }
  if (
    action.type == types.SET_TEMPLATE_PROGRESS_TYPE &&
    action.buttonType == "previous"
  ) {
    const prviousProgressIndex =
      PROGRESS_TYPES.findIndex((type) => state == type) - 1;
    return PROGRESS_TYPES[prviousProgressIndex];
  }
  if (action.type == types.UPDATE_TEMPLATE_PROGRESS_TYPE) {
    return action.progressType;
  }
  return state;
}
